/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetEquipmentDashboardQueryResponse, GetEquipmentDashboardPathParams, GetEquipmentDashboardQueryParams, GetEquipmentDashboard400, GetEquipmentDashboard401, GetEquipmentDashboard403, GetEquipmentDashboard404, GetEquipmentDashboard409, GetEquipmentDashboard500 } from "../../types/equipmentController/GetEquipmentDashboard.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getEquipmentDashboard } from "../../client/equipmentController/getEquipmentDashboard.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getEquipmentDashboardQueryKey = (organizationId: GetEquipmentDashboardPathParams["organizationId"] | undefined, params?: GetEquipmentDashboardQueryParams) => [{ url: '/api/organizations/:organizationId/equipment/dashboard', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetEquipmentDashboardQueryKey = ReturnType<typeof getEquipmentDashboardQueryKey>

export function getEquipmentDashboardQueryOptions(organizationId: GetEquipmentDashboardPathParams["organizationId"] | undefined, params?: GetEquipmentDashboardQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getEquipmentDashboardQueryKey(organizationId, params)
        return queryOptions<GetEquipmentDashboardQueryResponse, ResponseErrorConfig<GetEquipmentDashboard400 | GetEquipmentDashboard401 | GetEquipmentDashboard403 | GetEquipmentDashboard404 | GetEquipmentDashboard409 | GetEquipmentDashboard500>, GetEquipmentDashboardQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getEquipmentDashboard(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get equipment dashboard data
 * {@link /api/organizations/:organizationId/equipment/dashboard}
 */
export function useGetEquipmentDashboard<TData = GetEquipmentDashboardQueryResponse, TQueryData = GetEquipmentDashboardQueryResponse, TQueryKey extends QueryKey = GetEquipmentDashboardQueryKey>(organizationId: GetEquipmentDashboardPathParams["organizationId"] | undefined, params?: GetEquipmentDashboardQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetEquipmentDashboardQueryResponse, ResponseErrorConfig<GetEquipmentDashboard400 | GetEquipmentDashboard401 | GetEquipmentDashboard403 | GetEquipmentDashboard404 | GetEquipmentDashboard409 | GetEquipmentDashboard500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getEquipmentDashboardQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getEquipmentDashboardQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetEquipmentDashboard400 | GetEquipmentDashboard401 | GetEquipmentDashboard403 | GetEquipmentDashboard404 | GetEquipmentDashboard409 | GetEquipmentDashboard500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}